import { Business as BusinessIcon } from '@mui/icons-material';
import { Box, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

import { ClientInfoProps } from '../../types';

const ClientInfo: React.FC<ClientInfoProps> = ({ business }) => {
  if (!business) return null;

  return (
    <Paper
      sx={{
        p: '12px',
        mr: '20px',
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        position: 'relative',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ width: '100%' }}
      >
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            p: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <BusinessIcon sx={{ fontSize: '1rem' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          {business.businessName ? (
            <>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  fontSize: '1rem',
                  lineHeight: 1.1,
                }}
              >
                <strong>Empresa:</strong> {business.businessName}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <strong>RUT:</strong> {business.identifier}
              </Typography>
            </>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: '1rem',
                lineHeight: 1.1,
              }}
            >
              <strong>RUT:</strong> {business.identifier}
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
};

export default ClientInfo;
